import { useSetRecoilState } from 'recoil';
import { OVERLAY_KEYS } from '../constants';
import { OverlayState } from '../recoil/overlay/overlay.state';

export function useOverlay(
  modalName: OVERLAY_KEYS,
  id = ''
): [Function, Function] {
  const setOverlay = useSetRecoilState(OverlayState);

  const openOverlay = () => {
    // open up the modal with the given modal name
    setOverlay((prev) => ({
      ...prev,
      current: modalName,
      shouldShow: true,
      id: id,
    }));
  };
  const CloseOverlay = () => {
    // close up the modal with the given modal name
    setOverlay((prev) => ({
      ...prev,
      current: null,
      shouldShow: false,
      id: '',
    }));
  };

  return [openOverlay, CloseOverlay];
}
